<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmModal
			v-if="modalType === modalTypes.CONFIRM"
			v-model:report="report"
			v-model:success="successData"
			@close="cancelConfirm"
			@submit="submitReport"
			@success="success"
		/>
		<ExitConfirmModal
			v-if="modalType === modalTypes.EXIT"
			@close="cancelConfirm"
			@submit="exit"
		/>
	</DaModalFrame>
	<div class="flex min-h-screen overflow-x-hidden">
		<div
			:class="[
				[1].includes(step) && isOpen
					? 'content-report-is-show'
					: 'content-report-is-hide',
				[1].includes(step) ? 'transition' : '',
			]"
			class="w-full body-content"
		>
			<div class="w-full pb-30">
				<div class="w-full p-10 md-down:px-4 gap-4">
					<div
						class="
							__breadcrumbs
							text-sm text-neutral-500
							font-semibold
							flex-nowrap flex
							items-center
							justify-between
							mb-4
						"
					>
						<div>Làm báo cáo tuần</div>
						<button
							class="
								button-p
								text-center
								w-fit
								btn--text
								text-neutral-500
								hover:text-neutral-600
							"
							type="button"
							@click="openExitModalConfirm"
						>
							<svg
								class="mr-2 text-neutral-400"
								fill="none"
								height="16"
								viewBox="0 0 16 16"
								width="16"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
									fill="currentColor"
								/>
								<path
									d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
									fill="currentColor"
								/>
							</svg>
							Thoát
						</button>
					</div>
					<div
						class="
							flex
							sm:items-center
							justify-between
							flex-col
							sm:flex-row
						"
					>
						<div v-if="groupClass" class="flex gap-2">
							<div class="w-7 h-7">
								<img
									alt=""
									src="@/assets/images/icons/people-fill.png"
								/>
							</div>
							<div>
								<div
									class="text-neutral-700 font-bold text-3xl"
								>
									{{ groupClass?.name }}
								</div>
								<div class="flex gap-4 items-center mt-2">
									<UserGroup
										:data="groupClass?.students"
										placement="bottom-start"
									/>
									<div
										class="
											uppercase
											text-green-500
											font-semibold
										"
									>
										{{ groupClass?.students?.length }}
										học sinh
									</div>
								</div>
							</div>
						</div>
						<div class="md-down:mt-8 flex flex-wrap gap-4">
							<div v-if="step > 1" class="flex space-x-4">
								<button
									class="
										button-p
										text-center
										w-fit
										btn--ghost
									"
									type="button"
									@click="step -= 1"
								>
									<svg
										class="mr-2"
										fill="none"
										height="16"
										viewBox="0 0 16 16"
										width="16"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M10 4L6 8L10 12"
											stroke="#D89210"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
										/>
									</svg>
									Trở về bước {{ step - 1 }}
								</button>
							</div>
							<button
								v-if="[1].includes(step)"
								class="button-p text-center w-fit btn--ghost"
								type="button"
								@click="isOpen = true"
							>
								Xem trước MT cần báo cáo
							</button>
						</div>
					</div>
					<div>
						<div class="relative mt-12">
							<div
								aria-hidden="true"
								class="
									hidden
									xs:flex
									absolute
									inset-0
									items-center
								"
							>
								<div
									class="w-full border-t border-neutral-300"
								/>
							</div>
							<div
								class="
									relative
									flex
									xs:items-center
									justify-between
									flex-col
									xs:flex-row
								"
							>
								<span
									class="
										pr-3
										bg-body
										font-semibold
										text-sm text-neutral-600
									"
								>
									<span v-if="step === 1">
										Bước 1: Cho điểm & nhận xét từng mục
										tiêu
									</span>
									<span v-if="step === 2">
										Bước 2: Nhận xét chung
									</span>
								</span>
								<button
									:disabled="step === 1 && !enableStep2Button"
									class="
										button-p
										text-center
										whitespace-nowrap
										w-fit
									"
									type="button"
									@click="onNext"
								>
									<svg
										class="mr-2"
										fill="none"
										height="10"
										viewBox="0 0 6 10"
										width="6"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 9L5 5L1 1"
											stroke="currentColor"
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
										/>
									</svg>
									<span v-if="step === 1"
										>Bước 2: Nhận xét chung</span
									><span v-if="step === 2"
										>Hoàn thành báo cáo</span
									>
								</button>
							</div>
						</div>
						<div v-if="alertShow" class="mt-12">
							<div
								class="
									bg-yellow-50
									border-l-4 border-yellow-600
									p-4
									rounded-md
								"
							>
								<div class="relative">
									<div class="flex items-center gap-4">
										<div>
											<img
												alt="luca-logo"
												height="24"
												src="@/assets/images/logo/logo.svg"
												width="35"
											/>
										</div>
										<div
											class="
												pt-1
												text-neutral-600 text-sm
											"
										>
											Các bước để hoàn thành báo cáo tuần:
											<br />
											<br />
											1. Cho điểm từng mục tiêu
											<br />
											2. Nhận xét từng mục tiêu
											<br />
											<br />
											Bạn hãy hoàn thành Cho điểm từng mục
											tiêu của cả tuần để nộp báo cáo
										</div>
									</div>
									<div
										class="
											top-1
											right-2
											absolute
											cursor-pointer
										"
										@click="alertShow = false"
									>
										<svg
											fill="none"
											height="12"
											viewBox="0 0 12 12"
											width="12"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
												fill="#E5A42B"
												fill-rule="evenodd"
											/>
										</svg>
									</div>
								</div>
							</div>
						</div>
						<ReportDetailStep1
							v-if="report && step === 1"
							:goal="goalSelected"
							:groupClass="groupClass"
							:list_student_ids_learn_group_goal="
								list_student_ids_learn_group_goal
							"
							:report="report"
							:submitted-flag="submittedFlag"
							@fetchReportFilterByStudent="
								fetchReportFilterByStudent
							"
							@onNextGoal="onNextGoal"
							@onToGoal="onToGoal"
						/>
						<ReportDetail
							v-if="report && step === 2"
							:groupClass="groupClass"
							:report="report"
							@fetchReportFilterByStudent="
								fetchReportFilterByStudent
							"
							@submittedNote="submittedNote"
						/>
					</div>
				</div>
			</div>
			<div
				v-if="step === 1"
				:class="isOpen ? 'is-MT-show' : 'is-MT-hide'"
				class="bg-cream overflow-y-auto fixed right-0 top-0 pb-30"
				style="height: 100vh"
			>
				<div
					class="h-screen fixed top-0 right-0 overflow-y-auto"
					style="width: inherit; background: #faf5f1"
				>
					<GoalListForReport
						:goal-selected="goalSelected"
						:skills="skills"
						:step="step"
						@close="isOpen = false"
						@selected="changeGoalSelected"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UserGroup from '@/components/elements/UserGroup.vue';
import { _MODAL_TYPE, _MODAL_TYPE as modalTypes, _ROUTER_NAME } from '@/enums';
import GoalListForReport from '@/views/weekGroupEdit/GoalListForReport.vue';
import ReportDetailStep1 from '@/views/weekGroupEdit/ReportDetailStep1.vue';
import ReportDetail from '@/views/weekGroupEdit/ReportDetail.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import ConfirmModal from '@/views/weekGroupEdit/ConfirmModal.vue';
import { $api } from '@/services';
import ExitConfirmModal from '@/views/weekGroupEdit/ExitConfirmModal.vue';

export default {
	name: 'WeekGroupDetail',

	components: {
		ExitConfirmModal,
		ConfirmModal,
		DaModalFrame,
		ReportDetail,
		ReportDetailStep1,
		GoalListForReport,
		UserGroup,
	},

	data() {
		return {
			ROUTER_NAME: _ROUTER_NAME,
			alertShow: true,
			modalIsOpen: false,
			modalType: null,
			successData: false,
			step: 1,
			studentSelected: {
				id: 'all',
			},
			isOpen: true,
			goalIdSelected: null,
			goalSelected: null,
			goalTmpSelected: null,
			list_student_ids_learn_group_goal: [],
			skillIndex: 0,
			goalIndex: 0,
			report: null,
			groupClass: null,
			skills: [],
			submittedFlag: 0,
		};
	},

	watch: {
		goalIdSelected: {
			handler(value) {
				if (value) {
					this.fetchAssessmentsInReport();
				}
			},
			deep: true,
			immediate: true,
		},
	},

	computed: {
		modalTypes() {
			return modalTypes;
		},

		id() {
			return this.$route.params?.id;
		},

		week_start() {
			return this.$route.query?.week_start;
		},

		report_id() {
			return this.$route.query?.report_id;
		},

		enableStep2Button() {
			const listAssessment = this.skills.flatMap(
				(item) =>
					item.skill?.all_student_assessment_group_weekly_reports_done
			);

			return listAssessment.every((item) => !!item);
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},

	created() {
		this.fetchGroupClass(this.isAdmin);
		if (!this.report_id) {
			this.createReport();
		} else {
			this.fetchReport(this.report_id);
		}
	},

	methods: {
		async createReport() {
			try {
				const { data } =
					await $api.weeklyReport.createWeeklyReportGroup(this.id, {
						week_start: this.week_start,
					});
				await this.fetchReport(data?.data?.id);
			} catch (err) {
				const error =
					err?.response?.data?.errors?.join(<br />) ||
					err?.message ||
					'Đã có lỗi xảy ra. Vui lòng thử lại';
				await this.$store.dispatch('setAlertMessage', {
					message: error,
					type: 'danger',
				});
			}
		},

		async fetchGroupClass(isAdmin) {
			try {
				const { data } = await $api.groupClasses.detail(
					this.id,
					isAdmin
				);
				this.groupClass = data?.data;
			} catch (err) {
				const error =
					err?.response?.data?.errors?.join(<br />) ||
					err?.message ||
					'Đã có lỗi xảy ra. Vui lòng thử lại';
				await this.$store.dispatch('setAlertMessage', {
					message: error,
					type: 'danger',
				});
			}
		},

		async fetchReportFilterByStudent(payload) {
			const { studentId } = payload || {};

			if (!studentId) {
				return;
			}

			try {
				const { data } =
					studentId !== 'all'
						? await $api.weeklyReport.weeklyReportDetailGroupFilterByStudent(
								this.id,
								this.report?.data?.id,
								studentId
						  )
						: await $api.weeklyReport.weeklyReportDetailGroup(
								this.id,
								this.report?.data?.id
						  );
				this.report = {
					...this.report,
					...(studentId !== 'all' ? data?.data : data),
				};
			} catch (err) {
				const error =
					err?.response?.data?.errors?.join(<br />) ||
					err?.message ||
					'Đã có lỗi xảy ra. Vui lòng thử lại';
				await this.$store.dispatch('setAlertMessage', {
					message: error,
					type: 'danger',
				});
			}
		},

		async fetchSkillInReport() {
			const reportId = this.report?.data?.id;
			if (!reportId) {
				return;
			}

			try {
				const { data } = await $api.weeklyReport.skillInReport(
					this.id,
					reportId,
					this.report?.group_plan?.id
				);
				this.skills = data?.skills;
			} catch (err) {
				const error =
					err?.response?.data?.errors?.join(<br />) ||
					err?.message ||
					'Đã có lỗi xảy ra. Vui lòng thử lại';
				await this.$store.dispatch('setAlertMessage', {
					message: error,
					type: 'danger',
				});
			}
		},

		async fetchAssessmentsInReport() {
			try {
				const { data } = await $api.weeklyReport.assessmentsInReport(
					this.id,
					this.report?.data?.id,
					{
						group_goal_id: this.goalIdSelected,
					}
				);
				this.goalSelected = {
					...data?.goal,
					student_assessment_group_weekly_reports:
						this.groupClass?.students?.map((item) => {
							const assessment = data?.data.find(
								(i) => i.student_id === item.id
							);
							return {
								...assessment,
								student_id: item.id,
								group_goal_id:
									assessment?.group_goal_id ||
									this.goalIdSelected,
								note: assessment?.note || '',
								result: assessment?.raw_result,
								complete_percent: assessment?.raw_result
									? null
									: assessment?.complete_percent || 0,
								tab: 0,
							};
						}),
				};
				this.list_student_ids_learn_group_goal =
					data?.list_student_ids_learn_group_goal ?? [];
			} catch (err) {
				const error =
					err?.response?.data?.errors?.join(<br />) ||
					err?.message ||
					'Đã có lỗi xảy ra. Vui lòng thử lại';
				await this.$store.dispatch('setAlertMessage', {
					message: error,
					type: 'danger',
				});
			}
		},

		async fetchReport(reportId) {
			try {
				const { data } =
					await $api.weeklyReport.weeklyReportDetailGroup(
						this.id,
						reportId
					);
				this.report = {
					...data,
				};
				await this.fetchSkillInReport();
				this.goalIdSelected = this.skills[0]?.goals[0]?.id;
			} catch (err) {
				const error =
					err?.response?.data?.errors?.join(<br />) ||
					err?.message ||
					'Đã có lỗi xảy ra. Vui lòng thử lại';
				await this.$store.dispatch('setAlertMessage', {
					message: error,
					type: 'danger',
				});
			}
		},

		async submitReport() {
			try {
				await $api.weeklyReport.submitReport(
					this.id,
					this.report?.data?.id,
					{
						group_weekly_report: {},
					}
				);
				this.successData = true;
			} catch (err) {
				if (err?.response?.data?.errors_by_field?.state) {
					const error =
						err?.response?.data?.errors_by_field?.state?.join(
							<br />
						) || 'Đã có lỗi xảy ra. Vui lòng thử lại';
					await this.$store.dispatch('setAlertMessage', {
						message: error,
						type: 'danger',
					});
				} else {
					const error =
						err?.response?.data?.errors?.join(<br />) ||
						err?.message ||
						'Đã có lỗi xảy ra. Vui lòng thử lại';
					await this.$store.dispatch('setAlertMessage', {
						message: error,
						type: 'danger',
					});
				}
			}
		},

		cancelConfirm() {
			this.modalIsOpen = false;
			this.modalType = null;
		},

		openExitModalConfirm() {
			this.modalIsOpen = true;
			this.modalType = _MODAL_TYPE.EXIT;
		},

		exit() {
			this.$router.push({
				path: `/report/week/group-class`,
			});
		},

		success() {
			this.$router.push({
				path: `/report/week/group-class/${this.id}/${this.report?.data?.id}?week_start=${this.report?.data?.week_start}`,
			});
		},

		openConfirm() {
			this.modalIsOpen = true;
			this.modalType = _MODAL_TYPE.CONFIRM;
		},

		onNext() {
			if (this.step === 2) {
				this.openConfirm();
				return;
			}

			this.step += 1;
		},

		async changeGoalSelected(goal) {
			this.submittedFlag += 1;
			this.goalTmpSelected = goal;
		},

		submittedNote({
			all_student_group_weekly_report_completed,
			note,
			student_group_weekly_report_note,
		}) {
			this.report = {
				...this.report,
				data: {
					...this.report?.data,
					note,
				},
				all_student_group_weekly_report_completed,
				student_group_weekly_report_note,
			};
		},

		async onToGoal() {
			await this.fetchSkillInReport();
			this.goalIdSelected = this.goalTmpSelected?.id;
		},

		async onNextGoal() {
			await this.fetchSkillInReport();
			let skillIndex = -1;
			let goalIndex = -1;
			for (const sIndex in this.skills) {
				const skill = this.skills[sIndex];
				const index = skill.goals?.findIndex(
					(g) => g.id === this.goalIdSelected
				);

				if (index !== -1) {
					skillIndex = +sIndex;
					goalIndex = +index;
					break;
				}
			}

			const skill = this.skills[skillIndex];

			if (goalIndex === skill.goals?.length - 1) {
				this.goalIdSelected =
					skillIndex === this.skills?.length - 1
						? this.skills[0]?.goals?.[0]?.id
						: this.skills[skillIndex + 1]?.goals?.[0]?.id;
			} else {
				this.goalIdSelected = skill.goals[goalIndex + 1]?.id;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/responsive';

.is-MT-show {
	width: 100vw;
	transform: translateX(0);
	transition: all 0.4s ease;

	@include media-breakpoint-up(xl) {
		width: 360px;
	}
}

.is-MT-hide {
	transform: translateX(400px);
	transition: all 0.4s ease;
}

.transition {
	transition: all 0.4s ease;
}

.content-report-is-show {
	@include media-breakpoint-up(lg) {
		padding-right: 360px;
	}
}

.content-report-is-hide {
	@include media-breakpoint-up(lg) {
		padding-right: 0;
	}
}
</style>
